









import { Component, Vue, Prop } from "vue-property-decorator";
import Shangchuan from "./shangchuan.vue";
@Component({
  components: {
    Shangchuan
  }
})
export default class Shetaihoubao extends Vue {
  @Prop()
  private model: any;
  @Prop()
  private message: any;
  private messageChange(message) {
    this.$emit("update:message", message);
  }
}
